<template>
  <div class="width98 margin-auto">
    <div class="width100 flex-betweenNowrapAligns">
      <div class="backwhite width15 border-rd3 pad-bot30">
        <div class="width100 textalign-center">
          <el-image :src="avatar" class="head-img"></el-image>
        </div>
        <p class="textalign-center dimensional margin-top30">{{ realname }}</p>
        <p class="textalign-center f12 margin-top20" style="color: #969eac">
          注册时间 : {{ register_date }}
        </p>
        <div class="margin-top70 cursorpointer">
          <p
            class="width80 margin-auto flex-aroundnowrapcev"
            @click="dialogVisiblepassword = true"
          >
            <img src="@/assets/barsvg/32xgmm.svg" alt="" />
            <span class="f14">
              修改密码 <span class="bluecolor pad-left10"> ---</span>
            </span>
            <img src="@/assets/barsvg/xx／icon／16tz.png" alt="" />
          </p>
          <p
            class="width80 margin-auto flex-aroundnowrapcev margin-top30"
            @click="persongeren()"
          >
            <img src="@/assets/barsvg/32grzl.svg" alt="" />
            <span class="f14">
              个人资料 <span class="bluecolor pad-left10"> ---</span>
            </span>
            <img src="@/assets/barsvg/xx／icon／16tz.png" alt="" />
          </p>
        </div>
      </div>
      <div class="width84">
        <div
          class="backwhite flex-aroundnowrapcev border-rd3"
          style="padding: 20px 0"
        >
          <div
            class="width16 border-rd8 flex-leftnowrapcen"
            style="
              background: #f6f7fb;
              height: 110px;
              box-shadow: 0px 4px 5px -1px rgba(150, 158, 172, 0.3);
            "
          >
            <img
              class="margin-left20"
              style="width62px;height:62px"
              src="@/assets/barsvg/1@2x.png"
              alt=""
            />
            <div class="margin-left10">
              <p class="dimensional f20">{{ trademark }}</p>
              <p class="f12 margin-top10" style="color: #6a7589">关注商标数</p>
            </div>
          </div>
          <div
            class="width16 border-rd8 flex-leftnowrapcen"
            style="
              background: #f6f7fb;
              height: 110px;
              box-shadow: 0px 4px 5px -1px rgba(150, 158, 172, 0.3);
            "
          >
            <img
              class="margin-left20"
              style="width62px;height:62px"
              src="@/assets/barsvg/2@2x.png"
              alt=""
            />
            <div class="margin-left10">
              <p class="dimensional f20">{{ patent }}</p>
              <p class="f12 margin-top10" style="color: #6a7589">关注专利数</p>
            </div>
          </div>
          <div
            class="width16 border-rd8 flex-leftnowrapcen"
            style="
              background: #f6f7fb;
              height: 110px;
              box-shadow: 0px 4px 5px -1px rgba(150, 158, 172, 0.3);
            "
          >
            <img
              class="margin-left20"
              style="width62px;height:62px"
              src="@/assets/barsvg/3@2x.png"
              alt=""
            />
            <div class="margin-left10">
              <p class="dimensional f20">{{ message }}</p>
              <p class="f12 margin-top10" style="color: #6a7589">个人消息</p>
            </div>
          </div>
          <div
            class="width16 border-rd8 flex-leftnowrapcen"
            style="
              background: #f6f7fb;
              height: 110px;
              box-shadow: 0px 4px 5px -1px rgba(150, 158, 172, 0.3);
            "
          >
            <img
              class="margin-left20"
              style="width62px;height:62px"
              src="@/assets/barsvg/4@2x.png"
              alt=""
            />
            <div class="margin-left10">
              <p class="dimensional f20">{{ company }}</p>
              <p class="f12 margin-top10" style="color: #6a7589">关注企业数</p>
            </div>
          </div>
          <div
            class="width16 border-rd8 flex-leftnowrapcen"
            style="
              background: #f6f7fb;
              height: 110px;
              box-shadow: 0px 4px 5px -1px rgba(150, 158, 172, 0.3);
            "
          >
            <img
              class="margin-left20"
              style="width62px;height:62px"
              src="@/assets/barsvg/5@2x.png"
              alt=""
            />
            <div class="margin-left10">
              <p class="dimensional f20">{{ inner }}</p>
              <p class="f12 margin-top10" style="color: #6a7589">
                我加入的企业
              </p>
            </div>
          </div>
        </div>
        <div
          class="backwhite margin-top20 border-rd3"
          style="padding: 20px 0; min-height: 180px"
        >
          <p class="width96 margin-auto flex-betweenNowrapAlign">
            <span class="dimensional">我的日程安排</span>
            <span
              class="bluecolor f12 cursorpointer"
              @click="toreminderschedule"
              >更多</span
            >
          </p>

          <div class="width96 margin-auto">
            <p class="f14 flex-betweenNowrapAlign pad-top20">
              <span class="tdtit width30 tdconts">日程名称 </span
              ><span class="tdtit width50">备注 </span
              ><span class="tdtit width20">开始时间</span>
            </p>
            <p
              class="f14 flex-betweenNowrapAlign"
              v-for="(item, index) in pagedate.slice(0, 3)"
              :key="index"
            >
              <span class="tdcontss width30 text-ellipsis tdconts"
                >{{ item.title }} </span
              ><span class="tdcontss width50 text-ellipsis"
                >{{ item.remark }} </span
              ><span class="tdcontss width20">{{ item.start_at }}</span>
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="width100 backwhite margin-top15 pad-bot20">
      <p class="width98 margin-auto pad-top20">
        <span class="dimensional">我参与的任务</span>
      </p>
      <div class="width98 margin-auto">
        <p class="f14 flex-betweenNowrapAlign pad-top20">
          <span class="tdtit width20 tdconts">所属公司 </span
          ><span class="tdtit width15">项目名称 </span
          ><span class="tdtit width15">任务名称</span>
          <span class="tdtit width20">起止时间</span>
          <span class="tdtit width25">当前进度</span>
          <span class="tdtit width5">优先级</span>
        </p>
        <p
          class="f14 flex-betweenNowrapAlign"
          v-for="(item, index) in pagepro"
          :key="index"
        >
          <span class="tdcontss width20 text-ellipsis tdconts"
            >{{ item.company.company }} </span
          ><span class="tdcontss width15 text-ellipsis"
            >{{ item.project == null ? "" : item.project.title }} </span
          ><span class="tdcontss width15 text-ellipsis">{{ item.title }}</span
          ><span class="tdcontss width20"
            >{{ item.create_at == null ? "" : item.create_at.substring(0, 10) }}
            至
            {{
              item.end_date == null ? "" : item.end_date.substring(0, 10)
            }}</span
          ><span class="tdcontss width25">
            <el-progress
              class="margin-top15"
              :percentage="item.progress * 100"
              :color="customColorMethod"
            ></el-progress> </span
          ><span class="tdcontss width5">{{
            item.priority == 1 ? "高" : item.priority == 2 ? "一般" : "低"
          }}</span>
        </p>
      </div>
    </div>
    <el-dialog
      title=""
      :visible.sync="dialogVisiblenull"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="25%"
      class="errorbox"
    >
      <p class="textalign-left f16">提示</p>
      <div class="textalign-left margin-top10">
        <span class="errormessage">{{ errormessage }}</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <span @click="dialogVisiblenull = false" class="errorbutton">
          确 定
        </span>
      </span>
    </el-dialog>
    <el-dialog
      title="修改密码"
      :visible.sync="dialogVisiblepassword"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="25%"
      class="errorbox"
    >
      <el-form :model="inputTo" :rules="rules">
        <el-form-item prop="password" class="passwordbox">
          <el-input
            size="medium"
            type="password"
            v-model="inputTo.password"
            show-password
            placeholder="请输入新密码"
            ><i slot="prefix" class="el-icon-lock iconts"></i
          ></el-input>
        </el-form-item>
        <el-form-item prop="passwords" class="passwordbox">
          <el-input
            size="medium"
            type="password"
            v-model="inputTo.passwords"
            show-password
            placeholder="确认密码"
            ><i slot="prefix" class="el-icon-lock iconts"></i
          ></el-input>
        </el-form-item>

        <el-form-item>
          <el-button
            :style="{
              background:
                inputTo.password == 0
                  ? '#DFDFDF'
                  : '#52C5CB' && inputTo.passwords == 0
                  ? '#DFDFDF'
                  : '#52C5CB',
            }"
            :plain="true"
            @click="toVerifica()"
            type="primary"
            class="main-imgt"
            >确认</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
      title=""
      :visible.sync="dialogVisiblegeren"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="40%"
      class="errorbox"
    >
      <p class="textalign-left f16">个人资料</p>
      <div class="flex-around margin-top30">
        <div class="term-cont">
          <el-upload
            class="avatar-uploader"
            :action="Apisrc"
            name="images"
            :show-file-list="false"
            :on-success="handleAvatarSuccesshead"
            :on-error="handleerrorhead"
            :on-change="onchangehead"
            :data="userhead"
            :headers="head"
          >
            <img v-if="avatar" :src="avatar" class="head-imgs" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            <p class="f12 margin-right10">点击更换</p>
          </el-upload>
        </div>
        <div class="width70 bordert-left pad-left30">
          <el-form
            ref="form"
            :model="formgr"
            label-width="80px"
            class="width100"
          >
            <el-form-item label="真实姓名 :">
              <el-input v-model="formgr.realname"></el-input>
            </el-form-item>
            <el-form-item label="昵称 :">
              <el-input v-model="formgr.nickname"></el-input>
            </el-form-item>
            <el-form-item label="手机号码 :">
              <el-input v-model="formgr.mobile"></el-input>
            </el-form-item>
            <el-form-item label="联系地址 :">
              <el-input v-model="formgr.address"></el-input>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="textalign-right margin-top10">
        <el-button @click="nullbtn">取 消</el-button>
        <el-button type="primary" @click="savingbtn()">保 存</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import BUS from "@/BUS/BUS";
import {
  personalInformation,
  authprofile,
  indexdashboard,
} from "@/api/personal/personal.api";
import { authchangepwd } from "@/api/login/login.api";
import { calefind } from "@/api/patent/patent.api";
import { projecttaskindex } from "@/api/Center/Center.api";
export default {
  data() {
    return {
      errormessage: "",
      dialogVisiblenull: false,
      dialogVisiblepassword: false,
      dialogVisiblegeren: false,
      avatar: "",
      realname: "",
      register_date: "",
      percentage: 80,
      customColor: "#409eff",
      inputTo: {
        password: "",
        passwords: "",
      },
      rules: {
        password: [
          // 必填             提示信息              触发方式
          { required: true, message: "请输入密码!", trigger: "blur" }, //element-UI上的方式
          {
            trigger: "blur",
            validator: (rule, value, callback) => {
              var reg = /^\S{6,}$/;
              if (!reg.test(value)) {
                callback(new Error("不低于6位数"));
                return;
              } else {
                callback();
              }
            },
          }, //自定义校验
        ],
        passwords: [
          // 必填             提示信息              触发方式
          { required: true, message: "请输入密码!", trigger: "blur" }, //element-UI上的方式
          {
            trigger: "blur",
            validator: (rule, value, callback) => {
              var reg = /^\S{6,}$/;
              if (!reg.test(value)) {
                callback(new Error("不低于6位数"));
                return;
              } else {
                callback();
              }
            },
          }, //自定义校验
        ],
      },
      formgr: {
        realname: "",
        nickname: "",
        mobile: "",
        address: "",
      },
      userhead: {
        images: "",
      },
      user: {
        images: "",
      },
      head: {
        token: window.sessionStorage.getItem("token"),
      },
      Apisrc: "",
      company: "",
      inner: "",
      message: "",
      patent: "",
      trademark: "",
      date: new Date(),
      pagedate: [],
      pagepro: [],
      title: "",
    };
  },

  components: {},
  methods: {
    customColorMethod(percentage) {
      if (percentage < 30) {
        return "#909399";
      } else if (percentage < 70) {
        return "#e6a23c";
      } else {
        return "#67c23a";
      }
    },
    // 修改密码
    toVerifica() {
      if (this.inputTo.password == "" || this.inputTo.passwords == "") {
        return;
      } else {
        authchangepwd({
          password: this.inputTo.password,
          password_confirm: this.inputTo.passwords,
        }).then((res) => {
          if (res.data.code == 200) {
            this.$message({
              showClose: true,
              message: "修改成功",
              type: "success",
            });
            this.dialogVisiblepassword = false;
          } else {
            this.dialogVisiblenull = true;
            this.errormessage = res.data.msg;
            this.dialogVisiblepassword = false;
          }
        });
      }
    },
    // 保存
    savingbtn() {
      authprofile({
        realname: this.formgr.realname,
        nickname: this.formgr.nickname,
        avatar: this.avatar,
        mobile: this.formgr.mobile,
        address: this.formgr.address,
      }).then((res) => {
        if (res.data.code == 200) {
          this.$message({
            showClose: true,
            message: "保存成功",
            type: "success",
          });
          window.sessionStorage.setItem("avatar", this.avatar);
          BUS.$emit("avatar", this.avatar);
          this.dialogVisiblegeren = false;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    // 个人资料
    persongeren() {
      this.dialogVisiblegeren = true;
      personalInformation({ id: window.sessionStorage.getItem("id") }).then(
        (res) => {
          if (res.data.code == 200) {
            this.title = res.data.data.company.company;
            window.sessionStorage.setItem(
              "default",
              res.data.data.user.default_cid
            );
            if (res.data.data.user.avatar.indexOf("http://") == -1) {
              this.avatar = window.g.Apisrc + res.data.data.user.avatar;
            } else {
              this.avatar = res.data.data.user.avatar;
            }
            window.sessionStorage.setItem("personid", res.data.data.user.id);
            this.phonnumber = res.data.data.user.mobile;
            this.nickname = res.data.data.user.nickname;
            this.realname = res.data.data.user.realname;
            this.mobile = res.data.data.user.mobile;
            this.formgr.address = res.data.data.user.address;
            this.formgr.nickname = res.data.data.user.nickname;
            this.formgr.realname = res.data.data.user.realname;
            this.formgr.mobile = res.data.data.user.mobile;
            if (window.sessionStorage.getItem("default") == 0) {
              this.title = "个人版";
            } else {
              window.sessionStorage.setItem(
                "companytitle",
                res.data.data.company.company
              );
            }
            window.sessionStorage.setItem(
              "nickname",
              res.data.data.user.nickname
            );
            window.sessionStorage.setItem("mobile", res.data.data.user.mobile);
            window.sessionStorage.setItem(
              "realname",
              res.data.data.user.realname
            );
            window.sessionStorage.setItem(
              "address",
              res.data.data.user.address
            );
            window.sessionStorage.setItem(
              "last_ip",
              res.data.data.user.last_ip
            );
            window.sessionStorage.setItem(
              "personcreate_time",
              res.data.data.user.create_time
            );
            window.sessionStorage.setItem("avatar", this.avatar);
          } else {
            this.dialogVisiblenull = true;
            this.errormessage = res.data.msg;
          }
        }
      );
    },
    nullbtn() {
      this.dialogVisiblegeren = false;
      personalInformation({ id: window.sessionStorage.getItem("id") }).then(
        (res) => {
          if (res.data.code == 200) {
            this.title = res.data.data.company.company;
            window.sessionStorage.setItem(
              "default",
              res.data.data.user.default_cid
            );
            if (res.data.data.user.avatar.indexOf("http://") == -1) {
              this.avatar = window.g.Apisrc + res.data.data.user.avatar;
            } else {
              this.avatar = res.data.data.user.avatar;
            }
            window.sessionStorage.setItem("personid", res.data.data.user.id);
            this.phonnumber = res.data.data.user.mobile;
            this.nickname = res.data.data.user.nickname;
            this.realname = res.data.data.user.realname;
            this.mobile = res.data.data.user.mobile;
            this.formgr.address = res.data.data.user.address;
            this.formgr.nickname = res.data.data.user.nickname;
            this.formgr.realname = res.data.data.user.realname;
            this.formgr.mobile = res.data.data.user.mobile;
            if (window.sessionStorage.getItem("default") == 0) {
              this.title = "个人版";
            } else {
              window.sessionStorage.setItem(
                "companytitle",
                res.data.data.company.company
              );
            }
            window.sessionStorage.setItem(
              "nickname",
              res.data.data.user.nickname
            );
            window.sessionStorage.setItem("mobile", res.data.data.user.mobile);
            window.sessionStorage.setItem(
              "realname",
              res.data.data.user.realname
            );
            window.sessionStorage.setItem(
              "address",
              res.data.data.user.address
            );
            window.sessionStorage.setItem(
              "last_ip",
              res.data.data.user.last_ip
            );
            window.sessionStorage.setItem(
              "personcreate_time",
              res.data.data.user.create_time
            );
            window.sessionStorage.setItem("avatar", this.avatar);
          } else {
            this.dialogVisiblenull = true;
            this.errormessage = res.data.msg;
          }
        }
      );
    },
    // 上传头像
    handleAvatarSuccesshead(response, res, file) {
      if (response.msg == "上传文件后缀不允许") {
        this.dialogVisiblenull = true;
        this.errormessage = response.msg;
      } else {
        this.avatar = window.g.Apisrc + response.data.url;
        this.$message({
          showClose: true,
          message: "上传成功",
          type: "success",
        });
      }
    },
    handleerrorhead(err, file, fileList) {
      let error = err;
      this.$message({
        showClose: true,
        message: error,
        type: "error",
      });
    },
    onchangehead(file, fileList) {
      this.user.images =
        document.getElementsByClassName("el-upload__input")[0].value;
    },
    // 日程
    toreminderschedule() {
      this.$router.push({ path: "/Personal-Center/reminder-schedule" });
    },
  },
  created() {
    // 获取个人信息
    this.Apisrc = window.g.ApiUrl + "/oss_form";
    const id = window.sessionStorage.getItem("id");
    personalInformation({ id: id }).then((res) => {
      if (res.data.code == 200) {
        if (
          res.data.data.company.company == undefined ||
          res.data.data.company.company == null ||
          res.data.data.company.company == ""
        ) {
          this.dccompany == "个人版";
        } else {
          this.dccompany = res.data.data.company.company;
        }
        window.sessionStorage.setItem("default", "个人中心");
        window.sessionStorage.setItem(
          "authority",
          res.data.data.bind.authority
        );
        this.phonnumber = res.data.data.user.mobile;
        this.nickname = res.data.data.user.nickname;
        this.mobile = res.data.data.user.mobile;
        this.realname = res.data.data.user.realname;
        this.address = res.data.data.user.address;
        this.last_ip = res.data.data.user.last_ip;
        if (res.data.data.user.create_time == null) {
          this.register_date = "";
        } else {
          this.register_date = res.data.data.user.create_time.substring(0, 10);
        }

        this.personcreate_time = res.data.data.user.create_time;
        if (res.data.data.user.avatar.indexOf("http://") == -1) {
          this.avatar = window.g.Apisrc + res.data.data.user.avatar;
        } else {
          this.avatar = res.data.data.user.avatar;
        }
      } else {
        this.dialogVisiblenull = true;
        this.errormessage = res.data.msg;
      }
    });
    // 数据
    indexdashboard({ cate_id: id }).then((res) => {
      this.company = res.data.data.company;
      this.inner = res.data.data.inner;
      this.message = res.data.data.message;
      this.patent = res.data.data.patent;
      this.trademark = res.data.data.trademark;
    });
    //    日程
    var dd = this.date;
    dd.setDate(dd.getDate()); //获取AddDayCount天后的日期
    var y = dd.getFullYear();
    var m =
      dd.getMonth() + 1 > 9 ? dd.getMonth() + 1 : "0" + (dd.getMonth() + 1); //获取当前月份的日期
    var s = dd.getDate() > 9 ? dd.getDate() : "0" + dd.getDate();
    calefind({
      date: y + "-" + m + "-" + s,
      limit: 3,
    }).then((res) => {
      if (res.data.code == 200) {
        this.pagedate = res.data.data;
      } else {
        this.dialogVisiblenull = true;
        this.errormessage = res.data.msg;
      }
    });
    // 任务
    //项目
    projecttaskindex({
      page: this.thisNum,
    }).then((res) => {
      if (res.data.code == 200) {
        this.pagepro = res.data.data.data;
      } else {
        this.dialogVisiblenull = true;
        this.errormessage = res.data.msg;
      }
    });
  },
  mounted() {},
};
</script>
<style scoped>
.head-img {
  width: 90px;
  height: 90px;
  border-radius: 50%;
  vertical-align: middle;
  margin: 30px auto 0;
}
.tdtit {
  height: 40px;
  line-height: 40px;
  background: #f1f3f9;
  border-right: 1px solid rgba(233, 233, 233, 1);
  border-top: 1px solid rgba(233, 233, 233, 1);
  border-bottom: 1px solid rgba(233, 233, 233, 1);
  padding-left: 10px;
  font-size: 14px;
  color: #6a7589;
}
.tdcont {
  padding-left: 10px;
  height: 40px;
  line-height: 40px;
  font-size: 14px;
  color: #353a44;
}
.tdconts {
  border-left: 1px solid rgba(233, 233, 233, 1);
}
.tdcontss {
  padding-left: 10px;
  height: 40px;
  line-height: 40px;
  font-size: 14px;
  color: #353a44;
  border-right: 1px solid rgba(233, 233, 233, 1);
  border-bottom: 1px solid rgba(233, 233, 233, 1);
  border-top: none;
}
.main-imgt {
  width: 20%;
  height: 30px;
  font-size: 14px;
  background: #dfdfdf;
  border-radius: 5px;
  border: none;
  color: aliceblue;
}
.passwordbox {
  width: 100%;
  margin: 5px auto 0;
  height: 50px;
  border: none;
  outline: none;
  color: #b7b7b7 100%;
}
.avatar-uploader {
  width: 100px;
  height: 68px;
  border: 1px solid rgb(199, 198, 198);
  text-align: center;
  line-height: 68px;
}
.term-cont >>> .avatar-uploader {
  border: none;
}
.head-imgs {
  width: 60px;
  height: 60px;
  border-radius: 5px;
  vertical-align: middle;
  margin-right: 10px;
}
.errorbox >>> .el-dialog__body {
  text-align: center;
}
.errorbox >>> .el-dialog {
  position: relative;
  top: 20%;
}
</style>